import {
  CLEAR_NOTIFICATIONS,
  DELETE_NOTIFICATION,
  FETCH_NOTIFICATIONS_FAILURE,
  FETCH_NOTIFICATIONS_REQUEST,
  FETCH_NOTIFICATIONS_SUCCESS,
  HIDE_LOADER,
  SET_CURRENT_PAGE,
  SET_ITEM_PER_PAGES,
  SET_TOTAL_NOTIFICATIONS,
  SET_TOTAL_PAGES,
  SHOW_LOADER,
} from './NotificationsActions';

const initialState = {
  loading: false,
  notifications: [],
  currentPage: 0,
  itemPerPage: 4,
  totalPages: 0,
  totalNotifications: 0,
  error: null,
};

export default function notificationsReducer(state = initialState, action) {
  switch (action.type) {
    case SHOW_LOADER:
      return { ...state, loading: true };
    case HIDE_LOADER:
      return { ...state, loading: false };
    case FETCH_NOTIFICATIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        notifications: action.payload,
        error: null,
      };
    case SET_TOTAL_PAGES:
      return { ...state, totalPages: action.payload };
    case SET_CURRENT_PAGE:
      return { ...state, currentPage: action.payload };
    case SET_ITEM_PER_PAGES:
      return { ...state, itemPerPage: action.payload };
    case SET_TOTAL_NOTIFICATIONS:
      return { ...state, totalNotifications: action.payload };
    case FETCH_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        loading: false,
        notifications: [],
        error: action.payload,
      };
    case DELETE_NOTIFICATION:
      return {
        ...state,
        notifications: state.notifications.filter(
          (notification) => notification.id !== action.payload
        ),
      };
    case CLEAR_NOTIFICATIONS:
      return {
        ...state,
        notifications: [],
      };
    default:
      return state;
  }
}
